var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('secao-banner'),_c('secao-como-funciona'),_c('secao-recursos'),_c('secao-valor'),_c('secao-duvidas'),_c('secao-faca-teste'),_c('secao-segmentos'),_c('secao-parceiros')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }